import { Injectable, inject } from '@angular/core';
import { calculatePathScore } from '@functions';
import { BoxDetection } from '@models';
import { MetricsService, SimulationService } from '@services';
import { SceneStore } from '@stores';
import { metrics } from './metrics';

@Injectable({
  providedIn: 'root',
})
export class IntracorporealKnotMetricsService {
  private metricsService = inject(MetricsService);
  private sceneStore = inject(SceneStore);
  private simulationService = inject(SimulationService);

  metrics = metrics;

  trackLeftTool(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'leftTool');
  }

  trackRightTool(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'rightTool');
  }

  finalizeMetrics() {
    this.metrics.leftNeedleDriverPath.value = calculatePathScore({
      maxScore: 15,
      minValue: 170,
      maxValue: 490,
      value: this.metricsService.getToolDistance('leftTool'),
    });
    this.metrics.time.value = this.simulationService.recordingTime();
    this.metrics.rightNeedleDriverPath.value = calculatePathScore({
      maxScore: 15,
      minValue: 180,
      maxValue: 760,
      value: this.metricsService.getToolDistance('rightTool'),
    });

    this.sceneStore.updateMetrics(Object.values(this.metrics));
  }
}
